<template>
  <line
    :x1="startCoordinates.x"
    :y1="startCoordinates.y"
    :x2="endCoordinates.x"
    :y2="endCoordinates.y"
    :stroke-dasharray="4"
    :style="[
      isActive
        ? { stroke: 'rgb(255, 255, 255)', 'stroke-width': '2' }
        : { stroke: 'rgb(255, 153, 0)', 'stroke-width': '2' }
    ]"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  //  style="stroke:rgb(255, 153, 0);stroke-width:2"
  //style="[isActive ? {'stroke': 'rgb(255, 255, 255);', 'stroke-width': '2'} : {'stroke': 'rgb(255, 153, 0);', 'stroke-width': '2'}]"
  name: "MeasureSkeletonLine",
  props: {
    projection: String,
    startPoint: String,
    endPoint: String,
    crop: Object,
    width: Number,
    height: Number,
    zoom: Number,
    heightZoom: Number,
    isActive: Boolean
  },
  computed: {
    ...mapGetters(["getPoint", "getPictureHeight"]),
    startCoordinates() {
      const point = this.getPoint(this.startPoint, this.projection);
      return {
        y: point.y * this.getPictureHeight * this.heightZoom,
        x:
          this.projection === "back"
            ? point.x * this.width * this.crop.width * this.zoom
            : point.z * this.width * this.crop.width * this.zoom
      };
    },
    endCoordinates() {
      const point = this.getPoint(this.endPoint, this.projection);
      return {
        y: point.y * this.getPictureHeight * this.heightZoom,
        x:
          this.projection === "back"
            ? point.x * this.width * this.crop.width * this.zoom
            : point.z * this.width * this.crop.width * this.zoom
      };
    }
  }
};
</script>
